import {
  BasicPage,
  buildHtml,
  buildLink,
  RouteInput,
  RouteSlotInput,
} from '@luks/ui';
import { ComponentProps } from 'react';

import { helpfulness } from '../../commons/Helpfulness';
import { isDefined } from '../../commons/is-defined';
import { removeEmptyParagraphs } from '../../commons/preprocess-paragraphs';
import { SEO } from '../../commons/Seo';
import mapPageMetadata from '../../commons/useMetatags';
import { mapBreadcrumbs } from '../Breadcrumbs';
import { mapLocationHeader } from '../LocationHeader';
import { mapParagraphs } from '../paragraphs/AllParagraphs';
import { mapSidebar } from '../Sidebar';

export function mapBasicPage(
  input: BasicPageFragment,
): RouteInput<typeof BasicPage> {
  return {
    header: mapBasicPageHeader(input),
    body: [
      ...mapParagraphs(removeEmptyParagraphs(input.body)),
      ...mapParagraphs(removeEmptyParagraphs(input.bottom)),
      mapSidebar(input.sidebar),
      ...(input.translations?.length
        ? [
            {
              key: 'LinkList' as 'LinkList' /*🤯*/,
              input: {
                items: input.translations.filter(isDefined).map((item) => ({
                  title: item.translationsLanguageTitle || '',
                  Link: buildLink({ href: item.path }),
                })),
              },
            },
          ]
        : []),
      helpfulness(),
    ],
  };
}

export function mapBasicPageHeader(input: {
  title: string;
  description: string | undefined;
  locationHeader: LocationHeaderFragment | undefined;
  breadcrumbs: Array<BreadcrumbItemFragment>;
}): Array<RouteSlotInput<typeof BasicPage, 'header'>> {
  if (input.locationHeader?.location) {
    return [
      mapLocationHeader({
        ...input.locationHeader,
        breadcrumbs: input.breadcrumbs,
      }),
      {
        key: 'SubPageHeader',
        input: {
          headline: input.title,
          Description: input.description
            ? buildHtml(input.description)
            : undefined,
        },
      },
    ];
  }
  return [
    {
      key: 'ContentHeader',
      input: {
        ...mapBreadcrumbs(input.breadcrumbs),
        Title: buildHtml(input.title),
        Description: input.description
          ? buildHtml(input.description)
          : undefined,
      },
    },
  ];
}

export function mapBasicPageMetadata(
  input: BasicPageFragment,
): ComponentProps<typeof SEO> {
  return mapPageMetadata(input);
}
